import { render, staticRenderFns } from "./dvf-res-v2.vue?vue&type=template&id=1d476806&scoped=true"
import script from "./dvf-res-v2.vue?vue&type=script&lang=ts"
export * from "./dvf-res-v2.vue?vue&type=script&lang=ts"
import style0 from "./dvf-res-v2.vue?vue&type=style&index=0&id=1d476806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d476806",
  null
  
)

export default component.exports